import "./App.css";
import Routing from "./Routing";
import {
  BrowserView,
  MobileView,

} from "react-device-detect";

function App() {
  return (
    <div>
      <BrowserView>
        <Routing />
      </BrowserView>
      <MobileView>
        <Routing />
      </MobileView>
    </div>
  );
}

export default App;
